'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchMenu = void 0;
const $ = require("jquery");
class SearchMenu {
    constructor() {
        $('.trigFadeInSearchMenu').on('click', (e) => {
            const isOpen = $(e.currentTarget).attr('data-is-open');
            if (isOpen === 'false') {
                $(e.currentTarget).attr('data-is-open', 'true');
                $('.bulletFadeInSearchMenu').attr('data-is-open', 'true');
            }
            else {
                $(e.currentTarget).attr('data-is-open', 'false');
                $('.bulletFadeInSearchMenu').attr('data-is-open', 'false');
            }
        });
    }
}
exports.SearchMenu = SearchMenu;
exports.default = SearchMenu;
